import type {Endpoints} from "@hosttools/web/server/routes/routes.directBooking.types";
import {useContext, useMemo} from "react";

import {Base} from "../../../services/base";
import {HTTPContext} from "../../contexts";

export const useDirectBookingService = () => {
    const http = useContext(HTTPContext);
    const base = useMemo(() => new Base<Endpoints>(http), [http]);
    return base;
};
